import type { ConnectError } from "sj-ui-toolkit/src/client";

export const RESTART_HINT =
  "Please restart the connection from your MCP client to get a new sign-in link.";

export function isInvalidArgument(error: ConnectError): boolean {
  const code = String(error.code);
  return code === "invalid_argument" || code === "3" || code === "400";
}

export function isPermissionDenied(error: ConnectError): boolean {
  const code = String(error.code);
  return code === "permission_denied" || code === "7" || code === "403";
}

export function resolveHttpUrl(url: string): string | null {
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.protocol === "https:" || parsed.protocol === "http:") {
      return parsed.href;
    }
  } catch {
    // unparseable URL
  }
  return null;
}
